import banner from './resources/images/banner.jpg';
import ad1 from './resources/images/pic001.jpg';
import ad2 from './resources/images/pic002.jpg';
import ad3 from './resources/images/pic003.jpg';
// import footerBg from './resources/images/H2.png';
import React, { Component } from 'react';
import './App.css';
import moment from 'moment';

import { getPeriods, getStatisticToday, getStatistics } from './services/services';
import { AxiosResponse } from 'axios';

const beforeStartDownAnnounceDate = moment().format('YYYY-MM-DD 16:50:00');
const afterStartDownAnnounceDate = moment().format('YYYY-MM-DD 16:51:59');
const startDownAnnounceDate = moment().format('YYYY-MM-DD 16:52:00');
const endDownAnnouneDate = moment().format('YYYY-MM-DD 16:54:59');
const downAnnounceDate = moment().format('YYYY-MM-DD 16:55:00');

const beforeStartUpAnnounceDate = moment().format('YYYY-MM-DD 16:55:01');
const afterStartUpAnnounceDate = moment().format('YYYY-MM-DD 16:56:59');
const startUpAnnounceDate = moment().format('YYYY-MM-DD 16:57:00');
const endUpAnnouneDate = moment().format('YYYY-MM-DD 16:59:59');
const upAnnounceDate = moment().format('YYYY-MM-DD 17:00:00');

const randomNumber = () => {
  const rand = Math.floor(Math.random() * 10);
  // const two = Math.floor(Math.random() * 10);
  // const three = Math.floor(Math.random() * 10);
  // const four = Math.floor(Math.random() * 10);
  // const five = Math.floor(Math.random() * 10);

  return rand + "";
}

const getLoading = () => {
  return 'loading';
}

const imageLoading = () => {
  const images = [];
  for (let i = 0; i < 5; i++) {
    const image = <img
      style={{ marginRight: 2 }}
      src={require('./resources/images/loading.gif')}
      width={50}
      height={50}
      alt='number'
    />;

    images.push(image);
  }
  return images;
}

class App extends Component {
  _isMounted = false;
  timer: any = null;
  downTimer: any = null;
  upTimer: any = null;

  state = {
    isMobile: false,
    statistics: [],
    beforeStartDown: false,
    beforeStartUp: false,
    todayDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    announceStartDate: moment().format('YYYY-MM-DD 16:50:00'),
    announceEndDate: moment().format('YYYY-MM-DD 17:00:00'),
    onePrizes: {
      one: getLoading(),
      two: getLoading(),
      three: getLoading(),
      four: getLoading(),
      five: getLoading()
    },
    twoPrizes: {
      one: getLoading(),
      two: getLoading(),
      three: getLoading(),
      four: getLoading(),
      five: getLoading()
    },
    oldAnnounce: false,
    newAnnounce: false,
    downAnnounce: false,
    oldUpAnnounce: false,
    downRelease: false,
    upAnnounce: false,
  };

  componentWillUnmount(): void {
    this._isMounted = false;
    // clearInterval(this.timer);
    clearInterval(this.downTimer);
    clearInterval(this.upTimer);
    window.removeEventListener("resize", this.resizeWindow);
  }

  componentDidMount(): void {
    this._isMounted = true;
    this.getAllStatistics();
    window.addEventListener("resize", this.resizeWindow);
    this.resizeWindow();

    this.setTimer();
  }

  getAllStatistics = async () => {
    const response: AxiosResponse = await getStatistics();
    this.setState({
      statistics: response.data
    })
  }

  setTimer = () => {
    if (!this.timer) {
      this.timer = setInterval(() => {
        this.setState({ todayDate: moment().format('YYYY-MM-DD HH:mm:ss') });
        this.announce();
      }, 1000);
    }
  }

  announce = () => {
    const { announceStartDate, announceEndDate, todayDate } = this.state;

    if (moment(todayDate).toDate().getTime() < moment(announceStartDate).toDate().getTime()) {
      this.beforeAnnonce();
    } else if (
      moment(todayDate).toDate().getTime() >= moment(announceStartDate).toDate().getTime()
      && moment(todayDate).toDate().getTime() <= moment(announceEndDate).toDate().getTime()
    ) {
      this.setData();
    } else {
      this.afterAnnounce();
    }
  }

  beforeAnnonce = async () => {
    const { todayDate, oldAnnounce } = this.state;
    if (!oldAnnounce) {
      const dateNow = moment(todayDate).add(-1, 'd').format("YYYY-MM-DD 17:00:00");
      const period = await getPeriods(dateNow, 'both', '31');
      const up = period.data.up6;
      const down = period.data.down6;

      this.setState({
        onePrizes: {
          one: up[0],
          two: up[1],
          three: up[2],
          four: up[3],
          five: up[4],
        },
        twoPrizes: {
          one: down[0],
          two: down[1],
          three: down[2],
          four: down[3],
          five: down[4],
        },
        oldAnnounce: true
      })
    }
  }

  afterAnnounce = async () => {

    const { newAnnounce } = this.state;
    if (!newAnnounce) {
      const statisticToday = await getStatisticToday();

      const up = statisticToday.data.up6;
      const down = statisticToday.data.down6;

      this.setState({
        onePrizes: {
          one: up[0],
          two: up[1],
          three: up[2],
          four: up[3],
          five: up[4],
        },
        twoPrizes: {
          one: down[0],
          two: down[1],
          three: down[2],
          four: down[3],
          five: down[4],
        },
        newAnnounce: true
      })
    }

  }

  setData = async () => {
    const { todayDate, beforeStartDown, beforeStartUp, downAnnounce, oldUpAnnounce, downRelease, upAnnounce } = this.state;

    // --------------------- *** DOWN *** -------------------------
    // before start down
    if (moment(todayDate).toDate().getTime() >= moment(beforeStartDownAnnounceDate).toDate().getTime() && moment(todayDate).toDate().getTime() <= moment(afterStartDownAnnounceDate).toDate().getTime()) {
      if (!beforeStartDown) {
        this.setState({
          onePrizes: {
            one: getLoading(),
            two: getLoading(),
            three: getLoading(),
            four: getLoading(),
            five: getLoading()
          },
          twoPrizes: {
            one: getLoading(),
            two: getLoading(),
            three: getLoading(),
            four: getLoading(),
            five: getLoading()
          },
          beforeStartDown: true
        })
      }
    }

    // down random number started
    if (moment(todayDate).toDate().getTime() >= moment(startDownAnnounceDate).toDate().getTime() && moment(todayDate).toDate().getTime() <= moment(endDownAnnouneDate).toDate().getTime()) {
      if (!this.downTimer) {
        this.downTimer = setInterval(() => {
          this.setState({
            twoPrizes: {
              one: randomNumber(),
              two: randomNumber(),
              three: randomNumber(),
              four: randomNumber(),
              five: randomNumber(),
            }
          })
        }, 100);
      }
    }

    // down announce
    if (moment(todayDate).toDate().getTime() === moment(downAnnounceDate).toDate().getTime()) {
      if (this.downTimer) clearInterval(this.downTimer);
      // call api and show down
      if (!downAnnounce) {
        const dateNow = moment(todayDate).format("YYYY-MM-DD 17:00:00");
        const period = await getPeriods(dateNow, 'down', '31');
        const down = period.data.down6;

        this.setState({
          twoPrizes: {
            one: down[0],
            two: down[1],
            three: down[2],
            four: down[3],
            five: down[4]
          },
          downAnnounce: true
        });
      }
    }

    if (moment(todayDate).toDate().getTime() > moment(downAnnounceDate).toDate().getTime()) {
      if (this.downTimer) clearInterval(this.downTimer);
      // show release down
      if (!downRelease) {
        const dateNow = moment(todayDate).format("YYYY-MM-DD 17:00:00");
        const period = await getPeriods(dateNow, 'down', '31');
        const down = period.data.down6;

        this.setState({
          twoPrizes: {
            one: down[0],
            two: down[1],
            three: down[2],
            four: down[3],
            five: down[4]
          },
          downRelease: true
        });
      }
    }

    // --------------------- *** UP *** -------------------------
    if (moment(todayDate).toDate() < moment(startUpAnnounceDate).toDate()) {
      // show old up
      if (!oldUpAnnounce) {
        const dateNow = moment(todayDate).add(-1, 'd').format("YYYY-MM-DD 17:00:00");
        const period = await getPeriods(dateNow, 'up', '31');
        const up = period.data.up6;

        this.setState({
          onePrizes: {
            one: getLoading(),
            two: getLoading(),
            three: getLoading(),
            four: getLoading(),
            five: getLoading()
          },
          oldUpAnnounce: true
        });
      }

    }

    // before start up
    if (moment(todayDate).toDate() >= moment(beforeStartUpAnnounceDate).toDate() && moment(todayDate).toDate() <= moment(afterStartUpAnnounceDate).toDate()) {
      if (!beforeStartUp) {
        this.setState({
          onePrizes: {
            one: getLoading(),
            two: getLoading(),
            three: getLoading(),
            four: getLoading(),
            five: getLoading()
          },
          beforeStartUp: true
        })
      }
    }

    // up random number started
    if (moment(todayDate).toDate() >= moment(startUpAnnounceDate).toDate() && moment(todayDate).toDate() <= moment(endUpAnnouneDate).toDate()) {
      if (!this.upTimer) {
        this.upTimer = setInterval(() => {
          this.setState({
            onePrizes: {
              one: randomNumber(),
              two: randomNumber(),
              three: randomNumber(),
              four: randomNumber(),
              five: randomNumber()
            }
          })
        }, 100);
      }
    }

    // up announce
    if (moment(todayDate).toDate().getTime() === moment(upAnnounceDate).toDate().getTime()) {
      if (this.upTimer) clearInterval(this.upTimer);

      if (!upAnnounce) {
        // call api and show up 
        const statisticToday = await getStatisticToday();

        const up = statisticToday.data.up6;
        const down = statisticToday.data.down6;

        this.setState({
          onePrizes: {
            one: up[0],
            two: up[1],
            three: up[2],
            four: up[3],
            five: up[4]
          },
          twoPrizes: {
            one: down[0],
            two: down[1],
            three: down[2],
            four: down[3],
            five: down[4]
          },
          upAnnounce: true
        })
      }
    }
  }

  renderDate = () => {
    const { todayDate } = this.state;

    if (moment(todayDate).toDate().getTime() >= moment(beforeStartDownAnnounceDate).toDate().getTime()) {
      return moment().format("DD/MM/YYYY");
    }

    return moment().add(-1, 'd').format("DD/MM/YYYY");
  }

  resizeWindow = () => {
    const width = window.innerWidth;
    if (width <= 500) {
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  renderAnnounce = (prizes: any) => {

    if (prizes.one === 'loading') {
      return imageLoading();
    }

    return prizes.one + prizes.two + prizes.three + prizes.four + prizes.five;
  }

  render(): React.ReactNode {

    const { statistics, onePrizes, twoPrizes, isMobile } = this.state;
    return (
      <div className="container p-0">
        <div className="header d-flex justify-content-center">
          <img src={banner} className="img-fluid" height="250px" alt="hanoi" />
        </div>

        <div className="row pt-3">
          <div className="col-md-8 col-sm-12 col-xs-12">
            <div className="card d-flex justify-content-center mt-0 mb-2" style={{ border: 'none' }}>
              <div className="card-body p-0">
                {/* {!isMobile ? <div className="d-flex flex-row">
                  <h1 className="mr-3 mb-0 align-self-center" style={{ color: 'red' }}>TRỰC TIẾP XỔ SỐ MIỀN BẮC</h1>
                  <h1 className="mt-0 mb-0 align-self-center" style={{ fontFamily: 'PSL', color: 'black', fontSize: 52, fontWeight: 'bold' }}>{this.renderDate()}</h1>
                </div> : <div className="d-flex justify-content-center">
                  <h5 className="mr-3 mb-0 align-self-center" style={{ color: 'red' }}>TRỰC TIẾP XỔ SỐ MIỀN BẮC</h5>
                  <h4 className="mt-0 mb-0 align-self-center" style={{ fontFamily: 'PSL', color: 'black', fontSize: 40, fontWeight: 'bold' }}>{this.renderDate()}</h4>
                </div>
                } */}
                <div className="text-center pb-2" style={{ backgroundColor: '#8b0404' }}>
                  <span style={{ fontFamily: 'boonhome', fontWeight: 'bolder', fontSize: !isMobile ? '4rem' : 40 }} className="logo-gradient">Tanggal pengundian</span>
                  {!isMobile ? <div className="text-center">
                    <h1 className="mt-0 mb-0 align-self-center" style={{ fontFamily: 'boonhome', color: 'white', fontSize: !isMobile ? 52 : 48, fontWeight: 'bold' }}>{this.renderDate()}</h1>
                  </div> : <div className="text-center">
                    <h4 className="mt-0 mb-0 align-self-center" style={{ fontFamily: 'boonhome', color: 'white', fontSize: !isMobile ? 40 : 36, fontWeight: 'bold' }}>{this.renderDate()}</h4>
                  </div>
                  }
                </div>
              </div>
            </div>

            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td style={{ fontFamily: 'boonhome', fontSize: 24, textAlign: 'center', width: !isMobile ? 250 : 150, verticalAlign: 'middle', borderColor: '#B8B8B8' }}>
                    <span>Hadiah pertama</span>
                  </td>
                  <td colSpan={2} style={{ padding: 0, textAlign: 'center', verticalAlign: 'middle', borderColor: '#B8B8B8' }}>
                    <span style={{ fontSize: 64, fontWeight: 1000, letterSpacing: 4, fontFamily: 'PSL', color: 'red' }}>{this.renderAnnounce(onePrizes)}</span>
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#EBEBEB' }}>
                  <td style={{ fontFamily: 'boonhome', fontSize: 24, textAlign: 'center', width: !isMobile ? 250 : 150, verticalAlign: 'middle', borderColor: '#B8B8B8' }}>
                    <span>Hadiah kedua</span>
                  </td>
                  <td colSpan={2} style={{ padding: 0, textAlign: 'center', verticalAlign: 'middle', borderColor: '#B8B8B8' }}>
                    <span style={{ fontSize: 46, fontWeight: 1000, letterSpacing: 4, fontFamily: 'PSL' }}>{this.renderAnnounce(twoPrizes)}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="text-center p-1 mt-4" style={{ backgroundColor: '#8b0404' }}>
              <h3 className="text-center logo-gradient" style={{ fontFamily: 'boonhome' }}>Hasil penghargaan sebelumnya</h3>
            </div>
            <table className="table announce table-bordered table-striped m-0">
              <thead>
                <tr className="text-center" style={{ fontFamily: 'boonhome' }}>
                  <th style={{ verticalAlign: 'middle', width: '30%' }}>Tanggal</th>
                  <th style={{ verticalAlign: 'middle', width: '35%' }}>Hadiah pertama</th>
                  <th style={{ verticalAlign: 'middle', width: '35%' }}>Hadiah kedua</th>
                </tr>
              </thead>
              <tbody style={{ fontFamily: 'PSL', fontSize: 28 }}>
                {
                  statistics?.length > 0 ? statistics.map((v: any, index: number) => {
                    return <tr key={index + v.dateAnnounce}>
                      <td>{moment(v.dateAnnounce).format("DD-MM-YYYY")}</td>
                      <td>{v.up3}</td>
                      <td>{v.down2}</td>
                    </tr>
                  }) : <tr>
                    <td colSpan={3} style={{ fontSize: 16 }}>Không có thông tin</td>
                  </tr>
                }
              </tbody>
            </table>

          </div>
          <div className="col-md-4 col-sm-12 col-xs-12 ">
            <div className="card d-flex justify-content-center mt-0">
              <div className="card-body p-0">
                <img src={ad1} width="100%" height="300px" alt="" />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0">
                <img src={ad2} width="100%" height="300px" alt="" />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0" style={{ border: '1px solid gray', margin: 3 }}>
                <img src={ad3} width="100%" height="300px" alt="" />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="card d-flex justify-content-center mt-0" style={{ border: 'none' }}>
          <div className="card-body p-0">
            <img src={footerBg} width="100%" height="200px" alt="" />
          </div>
        </div> */}
      </div>
    )
  }
}
export default App;
